import React from 'react'
import { IconSearch, IconClose } from 'components/Zui/Icon'
import { Button, Textfield, ErrorMessage } from 'components/Zui'

import './index.css'

const Index = ({ onClear, onChange, validationError, icon = true, ...props }) => {
    return (
        <div className="searchbox-wrapper">
            <div className="search-field-wrapper">
                <Textfield
                    style={{ width: '100%' }}
                    input-type="text"
                    onInput={e => onChange(e.target.value)}
                    {...props}
                >
                    {icon && (
                        <zui-interactive-icon class="muted" slot="interactive-icon">
                            {!props.value ? (
                                <IconSearch size="m"></IconSearch>
                            ) : (
                                <IconClose size="m" onClick={onClear}></IconClose>
                            )}
                        </zui-interactive-icon>
                    )}
                </Textfield>
                {validationError && !props.isTyping && (
                    <ErrorMessage>{validationError}</ErrorMessage>
                )}
            </div>
            {props.button && <Button onClick={props.onClick}>{props.button}</Button>}
        </div>
    )
}

export default React.memo(Index)
